module.exports = __webpack_public_path__ + "static/img/index-background.27b77654.png";